import { useState, useEffect, useCallback } from "react";
import Chart from "chart.js";
import Header from "components/Headers/chatHeader.js";
import { CMM } from '../Lib/Cmm.js';
import axios from 'axios';
import { auto, right } from '@popperjs/core';
import { chartOptions, parseOptions, } from "variables/charts.js";
import { GoChevronRight, GoChevronLeft } from "react-icons/go";
import { AiOutlineDoubleLeft, AiOutlineDoubleRight } from "react-icons/ai";
import { fetchAxios, postAxios, postNoauth } from 'Lib/GetAxios';

import {
  Button,
  Card,
  CardHeader,
  CardBody,
  ListGroup,
  ListGroupItem,
  Container,
  Row,
  Col,
} from "reactstrap";

let maxPageNo;

const ChatBorder = (props) => {
  const [messages, setMessages] = useState([]);
  const [chatRooms, setChatRooms] = useState([]);
  const [selectRooms, setSelectRooms] = useState('');
  const [selectChatRoomNamechatRooms, setSelectChatRoomNamechatRooms] = useState([]);

  const [user_idx, setUser_idx] = useState('');
  const [viewNo, setViewNo] = useState(3);
  const [selectNo, setSelectNo] = useState(1);

  const [inputMessage, setInputMessage] = useState('');

  useEffect(() => {

    chatListDate();
    chatListDateCnt();
    getUserIdx();

  }, [])

  useEffect(() => {
    chatListDate();
  }, [selectNo]);

  //
  const getUserIdx = useCallback(() => {

    fetchAxios(`${CMM.SERVER_URL_API}/admin/get_user_idx`,
      {})
      .then((res) => {
        if (res != 'ERROR') {
          setUser_idx(res[0].user_idx);

        }
      })
      .catch((e) => {
        console.log('error::', e.message)
      })

  }, [selectNo]);

  //채팅 리스트 데이터 가져오기
  const chatListDate = useCallback(() => {

    fetchAxios(`${CMM.SERVER_URL_API}/chat/chat_room_list`,
      {
        // user_idx: user_idx,
        pageno: selectNo,
      })
      .then((res) => {
        if (res != 'ERROR') {
          // console.log(res);
          setChatRooms(res);

        }
      })
      .catch((e) => {
        console.log('error::', e.message)
      })

  }, [selectNo]);

  //채팅방 개수
  const chatListDateCnt = useCallback(() => {

    fetchAxios(`${CMM.SERVER_URL_API}/chat/chat_room_lis_cnt`,
      {})
      .then((res) => {
        if (res != 'ERROR') {
          // console.log('::::::::::::::::::::::::::::::', res);
          var roomCnt = res[0].totalRows;
          maxPageNo = Math.ceil(roomCnt / 10);

        }
      })
      .catch((e) => {
        console.log('error::', e.message)
      })
  }, [maxPageNo]);

  //채팅방 리스트 view
  const ChatRoomList = ({ rooms, onRoomClick }) => {
    var sumNO = 0;

    if (selectNo > 1) {
      sumNO = 10 * (selectNo - 1)
    }

    return (
      <ListGroup flush>
        {rooms.map((room, index) => (
          <ListGroupItem key={index} onClick={() => onRoomClick(room.cr_idx, index + 1)}>

            <span>고객문의 {index + 1 + sumNO}</span>

            {/* <span className={room.close_yn == 'Y' ? "bg-danger rounded-circle d-inline-block align-items-end" : "bg-success rounded-circle d-inline-block align-items-end"}
              style={{ width: '15px', height: '15px', float: 'right' }}></span> */}

          </ListGroupItem>
        ))}
      </ListGroup>
    );
  };

  //선택한 채팅방 데이터 가져오기
  const handleRoomClick = useCallback((cr_idx, index) => {

    var sumNO = 0;

    if (selectNo > 1) {
      sumNO = 10 * (selectNo - 1)
    }

    fetchAxios(`${CMM.SERVER_URL_API}/chat/chat_date`,
      {
        cr_idx: cr_idx,
      })
      .then((res) => {
        if (res != 'ERROR') {
          setSelectChatRoomNamechatRooms('고객문의' + (index + sumNO));
          setSelectRooms(chatRooms[index - 1]);
          setMessages(res);

        }
      })
      .catch((e) => {
        console.log('error::', e.message)
      })

  }, [selectNo, chatRooms]);

  const dateTime = (date, type) => {
    const dateObject = new Date(date);

    const hour = dateObject.getHours(); // 시간 (0-23)
    const minute = dateObject.getMinutes(); // 분 (0-59)
    const formattedMinutes = minute < 10 ? `0${minute}` : minute;

    //채팅방 선택 안했을 때
    if (date == '' || date == undefined) {
      return '';
    }

    if (type == 'chatRoom') {
      return dateObject.toLocaleDateString('ko-KR', { year: 'numeric', month: 'long', day: 'numeric', weekday: 'long' });
    }
    if (type == 'message') {
      if (hour < 12) {
        const time = '오전 ';
        const returnDate = `${time} ${hour}:${formattedMinutes}`;

        return returnDate;
      } else {
        const time = '오후 ';
        const returnDate = `${time} ${hour - 12}:${formattedMinutes}`;

        return returnDate;
      }
    }

  }

  //고객 채팅 전송
  const handleSendMessage = useCallback(() => {

    // if (inputMessage.trim() !== '') {
    //   const newMessage = {
    //     room_nm: uniqueId,
    //     text: inputMessage,
    //     ownerType: 'user',
    //     idx: user_idx,
    //     u_uuid: uniqueId
    //   };
    //   if (socket) {
    //     setMessages((prevMessages) => [...prevMessages, newMessage]);
    //     socket.emit('newMessage', newMessage);
    //     scrollToBottom();
    //   }
    //   setInputMessage('');
    // }
  }, [inputMessage]);

  //엔터키 이벤트
  const activeEnter = (e) => {
    if (e.nativeEvent.isComposing) { 	   // isComposing 이 true 이면 
      return;				   // 조합 중이므로 동작을 막는다.
    }

    if (e.key === 'Enter' && e.shiftKey) { // [shift] + [Enter] 치면 걍 리턴
      return;
    } else if (e.key === 'Enter') {
      e.preventDefault();	   // [Enter] 치면 메시지 보내기
      handleSendMessage(e);
    }
  };

  //페이지 이동 버튼
  const PageNoBtn = ({ maxPage }) => {

    const handleButtonClick = (number) => {
      setSelectNo(number);
    };

    const getPageNumbers = () => {
      const numbers = [];
      const start = Math.max(1, Math.min(viewNo - 2, maxPage - 4)); // 시작 페이지
      const end = Math.min(start + 4, maxPage); // 끝 페이지

      for (let i = start; i <= end; i++) {
        numbers.push(i);
      }

      return numbers;
    };

    return (
      <Row className="justify-content-center">
        <Button
          className="btn btn-sm text-break ml-2 mr-2 shadow-none border-0 bg-white"
          onClick={(e) => {
            e.preventDefault();
            setViewNo(3);
            console.log(viewNo);
          }}><AiOutlineDoubleLeft /></Button>
        <Button
          className="btn btn-sm text-break ml-2 mr-2 shadow-none border-0 bg-white"
          onClick={(e) => {
            e.preventDefault();
            if (viewNo >= 3) {
              setViewNo(viewNo - 5);
            }
          }}><GoChevronLeft /> </Button>
        {getPageNumbers().map((index) => (
          <Button
            key={index}
            className={`btn btn-sm text-break ml-3 mr-3 shadow-none border-0 `}
            style={selectNo == index ? { backgroundColor: '#3094FF', color: '#fff', alignItems: 'center' } : { backgroundColor: '#FFF', alignItems: 'center' }}
            onClick={() => handleButtonClick(index)}
          >
            {index}
          </Button>
        ))}
        <Button
          className="btn btn-sm text-break ml-2 mr-2 shadow-none border-0 bg-white"
          onClick={(e) => {
            e.preventDefault();
            if (viewNo <= maxPageNo - 4) {
              setViewNo(viewNo + 5);
            }
          }}><GoChevronRight /></Button>
        <Button
          className="btn btn-sm text-break ml-2 mr-2 shadow-none border-0 bg-white"
          onClick={(e) => {
            e.preventDefault();
            setViewNo(maxPageNo - 2);
            console.log(viewNo);
          }}>< AiOutlineDoubleRight /></Button>
      </Row>
    );
  }

  if (window.Chart) {
    parseOptions(Chart, chartOptions());
  }

  return (
    <>
      <Header />
      {/* Page content */}
      <Container className="mt--7 position-absolute start-0" fluid style={{ maxWidth: '1300px', }}>
        <Card className="bg-white">
          <CardHeader className="bg-white">
            <div className="font-weight-bold d-none d-sm-block"
              style={{ lineHeight: 1.2 }}>
              <h1 className="d-inline-block"
                style={{ color: 'black' }}>
                채팅</h1>
              <div className=""
                style={{ color: '#727272' }}>
                고객의 질문에 대응하는 답변을 입력하고 관리할 수 있습니다.
              </div>
              <div className=""
                style={{ color: '#727272' }}>
                상품 소개, 문의하기 등 링크를 달아 더 많은 정보를 제공할 수 있습니다.
              </div>
            </div>
            <div className="font-weight-bold d-sm-none "
              style={{ lineHeight: 1.2 }}>
              <h2 className="d-inline-block"
                style={{ color: 'black' }}>
                채팅</h2>
              <div className="   "
                style={{ color: '#727272', fontSize: '14px' }}>
                고객의 질문에 대응하는 답변을 입력하고 관리할 수 있습니다.
              </div>
              <div className=" "
                style={{ color: '#727272', fontSize: '14px' }}>
                상품 소개, 문의하기 등 링크를 달아 더 많은 정보를 제공할 수 있습니다.
              </div>
            </div>
          </CardHeader>
          <CardBody className="p-0 bg-white ">
            <Row className=" px-3">
              <Col className="mb-xl-0 p-0" xl="6">
                <Card className="">
                  <CardHeader className="" style={{ height: '50', overflowY: 'auto' }} >
                    <Row className="align-items-center">
                      <div className="col">
                        <h3 className="mb-0">채팅방 리스트</h3>
                      </div>
                    </Row>
                  </CardHeader>
                  <CardBody className="p-0" style={{ height: '55vh', overflowY: 'auto', maxHeight: '580px' }}>
                    <ChatRoomList rooms={chatRooms} onRoomClick={handleRoomClick} />
                  </CardBody>
                  <div className="p-2 bg-white " style={{ height: '70px' }} >
                    <PageNoBtn maxPage={maxPageNo} />
                  </div>
                </Card>
              </Col>
              <Col xl="6" className="p-0">
                <Card className="" >
                  <CardHeader className="bg-transparent" style={{ height: '50', overflowY: 'auto' }} >
                    <Row className="align-items-center">
                      <div className="col">
                        <h3 className="mb-0">채팅 {selectChatRoomNamechatRooms}
                          {/* <span style={{ float: 'right', fontWeight: 'normal', }}>{selectRooms === '' ? '' : (selectRooms.close_yn == 'N' ? <span className='text-success '>문의중</span> : <span className=' text-danger'>문의 종료</span>)}</span> */}
                        </h3>
                      </div>
                    </Row>
                  </CardHeader>
                  {
                    (selectRooms) ?
                      <CardBody className='p-0 ' style={{ height: '55vh', overflowY: 'auto', maxHeight: '580px' }}>
                        <style>
                          {`
                            /* Chrome 및 Safari 스크롤바 숨기기 */
                            ::-webkit-scrollbar {
                              width: 0 !important; /* 스크롤바 너비를 0으로 설정하여 숨깁니다. */
                            }
                          `}
                        </style>
                        <div className="container mt-1 text_div no-scrollbars">
                          <div className='p-1 text-center ' style={{ fontSize: '15px' }}>{dateTime(selectRooms.cre_dt, 'chatRoom')}</div>
                          {messages.map((message, index) => (
                            <div key={index} className={message.user_idx != user_idx ? "row align-items-center my-3 no-scrollbars " : "  row align-items-center my-3 no-scrollbars"} >
                              <div className="col-12" style={message.user_idx != user_idx ? {} : { textAlign: 'right', marginLeft: auto }}>
                                <div className="rounded p-2 d-inline-block" style={message.user_idx == user_idx ? { maxWidth: '70%', backgroundColor: '#E6E6E6', color: '#000000', textAlign: 'center', minWidth: '150px' } : { maxWidth: '70%', backgroundColor: '#2E9AFE', color: '#ffffff', }}>
                                  {
                                    message.chat_type != 'B' ?
                                      message.msg
                                      :
                                      <div className="col">
                                        <div className="text-left">정확한 답변을 위해</div>
                                        <div className='mb-2 text-left'>아래의 보기를 클릭해주세요.</div>
                                        {message.msg.split(',').map((text, index2) => (
                                          text.trim() && <div key={index2} className="bg-white p-2 my-2 rounded" style={{ border: (messages[index + 1] && messages[index + 1].msg.trim() == text.trim()) ? '1.5px solid #0591D9' : '1.5px solid #ffffff', color: (messages[index + 1] && messages[index + 1].msg.trim() == text.trim()) ? '#0591D9' : '#000000', }}>{text}</div>
                                        )
                                        )}
                                      </div>
                                  }
                                </div>
                                <div style={{ fontSize: '14px' }}>{dateTime(message.cre_dt, 'message')}</div>
                              </div>
                            </div>
                          ))}
                          <div className="container mt-3">
                            <div className="input-group">
                              <div className="input-group-append">
                              </div>
                            </div>
                          </div>
                        </div>
                      </CardBody> :
                      <CardBody className='p-0 ' style={{ height: '55vh', overflowY: 'auto', maxHeight: '580px' }}>
                        <style>
                          {`
                            /* Chrome 및 Safari 스크롤바 숨기기 */
                            ::-webkit-scrollbar {
                              width: 0 !important; /* 스크롤바 너비를 0으로 설정하여 숨깁니다. */
                            }
                          `}
                        </style>
                        <div className=" text-center mt-5"
                          style={{ color: '#757575' }}>
                          채팅방을 선택하세요.
                        </div>
                      </CardBody>
                  }

                  {/* <div className="p-3 bg-white" style={{ height: '70px' }} >
                    <div className={selectRooms == '' ? "d-none" : (selectRooms.close_yn == 'Y' ? 'd-none' : "visible")}>
                      <div className={!inChat ? "visible" : "d-none"}>
                        <button
                          className="btn text-white  w-100 "
                          style={{ fontWeight: 'normal', backgroundColor: '#3094FF' }}
                          onClick={(e) => {
                            e.preventDefault();
                            setInChat(true);
                          }}>채팅 참여</button>
                      </div>
                      <div className={inChat ? "visible" : "d-none"}>
                        <input
                          // ownerType="text"
                          className="form-control text-dark"
                          style={{ boxShadow: "none" }}
                          placeholder="메시지를 입력하세요"
                          onKeyDown={(e) => activeEnter(e)}
                          value={inputMessage}
                          onChange={(e) => {
                            setInputMessage(e.target.value)
                          }}
                        />
                      </div>
                    </div>
                  </div> */}
                </Card>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Container >
    </>
  );
};

export default ChatBorder;
